var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tg-panel--wrapper"},[_c('div',{staticClass:"tg-panel--title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"tg-panel--container"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }